export enum enumLedType {
    Led_Normaal = 34,
    Led_Dimbaar = 35,
    Alleen_Gat = 36
}
